import { createFileRoute } from '@tanstack/react-router';
import { FEATURE_FLAG } from '~/constants';

import { RouteExportParams } from '~/types/router.type';

import { ScansImportPage } from '~/modules/deliveryScans';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.scanImport.heading, { ns: 'deliveryScans' });

const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
  featureFlag: FEATURE_FLAG.DLN_LIST_V2,
};

export const Route = createFileRoute('/(main)/deliveries/scans/import/')({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/scans/import/',
    ...routeParams,
  }),
  component: ScansImportPage,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
      backLink: '/deliveries/scans/',
    },
  },
  wrapInSuspense: true,
});

export const DELIVERY_SCANS_IMPORT = buildRouteExport({
  Route,
  ...routeParams,
});
